import React, { Component } from 'react';
import styled from 'styled-components';
import { } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { connect } from 'react-redux';
import { modalActions, addAccountActions, accountActions } from '../../../redux/root-action';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import {
  formatAmountWithoutDollarAndDecimals,
  isNumeric,
  getIntegerAmount,
  formatAmountWithoutDecimals,
  annualERContTooltip,
  annualEEContTooltip,
  isEligbleForEEContribution,
  isEligbleForERContribution,
} from '../../../utils/helpers';
import { Input, Dropdown, GlobalErrorComponent, Tooltip } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { accountTypeCodes, defaultOption } from '../../../utils/constants';

const StyledFieldContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  @media only screen and (max-width: 767px) {
    margin-top: 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  ul {
    max-height: 320px;
    @media only screen and (max-width: 767px) {
      max-height: 240px;
    }
  }
`;

const StyledInputLabel = styled.div`
  height: 56px;
  flex: 190px 0;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    height: auto;
    flex: 0;
  }
`;

const StyledInputValue = styled.div`
  height: 56px;
  width: 256px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  > div {
    width: 256px;
  }
  @media only screen and (max-width: 767px) {
    height: auto;
    > div {
      width: 100%;
    }
  }
`;

const NQDisclaimer = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 14px;
  line-height: 18px;
  color: ${tokens.ColorGrey600};
  padding-left: 190px;
  @media only screen and (max-width: 767px) {
    padding-left: 0;
  }
`;

let isNonQual = false;

class AddAccountBaseFields extends Component<any, any> {
  componentDidMount() {
    const {
      account: { selectedAccount },
    } = this.props;

    if (selectedAccount.type === 'NQDC') {
      isNonQual = true;
    }
  }

  annualSavingsTooltip = () => {
    return `<div
        id="annual-savings-tooltip"
        role="tooltip"
        style=" width: 128px;height: 80px;font-family: Nimbus Sans Regular;font-size: 16px;padding: 8px 0px 8px 0px;"
      >
        Amount you expect to save in this account each year
      </div>`;
  };

  handleChange = (event: any) => {
    const { updateSelectedAccount } = this.props;
    const value = event.target.value;
    if (value.length > 35) {
      return;
    }

    updateSelectedAccount({
      [event.target.name]: value,
    });
  };

  handleAmountChange = (event: any) => {
    const { updateSelectedAccount } = this.props;
    if (!isNumeric(getIntegerAmount(event.target.value))) {
      return;
    }

    updateSelectedAccount({
      [event.target.name]: getIntegerAmount(event.target.value),
    });
  };

  handleAccountTypeOptionChange = (option: any) => {
    const {
      updateSelectedAccount,
      account: { selectedAccount },
    } = this.props;
    isNonQual = false;    
    updateSelectedAccount({
      annualSavingsEE: isEligbleForEEContribution(option.contributionType) ? formatAmountWithoutDollarAndDecimals(option.annualSavingsEE) : '',
      annualSavingsER: isEligbleForERContribution(option.contributionType) ? formatAmountWithoutDollarAndDecimals(option.annualSavingsER) : '',
      overrideAccountTypeCode: option.value,
      selectedAccountType: option,
      contributionType: option.contributionType,
    });    
    if (option.value === 'NQDC') {
      isNonQual = true;
    }
  };

  handleAccountHolderOptionChange = (option: any) => {
    const { updateSelectedAccount } = this.props;
    updateSelectedAccount({
      accountHolder: option.name,
    });
  };

  render(): JSX.Element {
    const {
      account: { selectedAccount, accountHolderOptions },
      accountTypes,
    } = this.props;

    const {
      name,
      balance,
      annualSavingsEE,
      annualSavingsER,
      accountHolder,
      error = {},
      selectedAccountType = defaultOption,
      contributionType,
      isYodleeAccount,
      isNewAccount,
    } = selectedAccount;

    const mq = window.matchMedia('(max-width: 767px)');
    const accountError = !accountTypes || accountTypes.length < 0;
    return (
      <React.Fragment>
        {accountError ? (
          <GlobalErrorComponent
            message={`We’re having trouble displaying your accounts. Please try again.`}
            refreshText={`Refresh List`}
            hideOverlay={true}
          />
        ) : (
          <>
            <StyledFieldContainer>
              <StyledInputLabel>Account Type</StyledInputLabel>
              {isNewAccount || isYodleeAccount || selectedAccount.type !== "Hsa" ? (
                <StyledInputValue>
                  <Dropdown
                    label="Select"
                    options={
                      isNewAccount ? accountTypes : isYodleeAccount ? accountTypes.slice(0, accountTypes.length - 1) :  accountTypes
                    }
                    onChange={(option: any) => this.handleAccountTypeOptionChange(option)}
                    selectedOption={selectedAccountType}
                    name="overrideAccountTypeCode"
                    width={mq.matches ? '100%' : 256}
                    errorMessage={error.accountType}
                  />
                </StyledInputValue>
              ) : (
                <StyledInputValue>{selectedAccountType.name}</StyledInputValue>
              )}
            </StyledFieldContainer>
            {isNonQual && (
              <StyledFieldContainer>
                <NQDisclaimer>
                  Future deferrals from this account will not be included in your projections. Balance will be projected
                  based on account allocation.
                </NQDisclaimer>
              </StyledFieldContainer>
            )}
            <StyledFieldContainer>
              <StyledInputLabel>Account Name </StyledInputLabel>
              {isYodleeAccount || selectedAccount.type === "Hsa" ? (
                <StyledInputValue>{name}</StyledInputValue>
              ) : (
                <Input
                  name="name"
                  value={name ? name : ''}
                  placeholder="Account Name"
                  onChange={this.handleChange}
                  autoComplete="off"
                  aria-label="accountName"
                  width={mq.matches ? '100%' : 256}
                  errorMessage={error.name}
                />
              )}
            </StyledFieldContainer>
              <StyledFieldContainer>
                <StyledInputLabel>{selectedAccount.type === "Hsa" && selectedAccount.displayGroup === "T. Rowe Price Retirement Accounts" ? "Investment Balance" : "Balance"}</StyledInputLabel>
                {isYodleeAccount || selectedAccount.type === "Hsa" ? (
                  <StyledInputValue>{balance ? formatAmountWithoutDecimals(balance) : ''}</StyledInputValue>
                ) : (
                  <StyledInputValue>
                    <Input
                      name="balance"
                      value={balance ? formatAmountWithoutDollarAndDecimals(balance) : ''}
                      placeholder="Account Balance"
                      leadingCharacter="$"
                      onChange={this.handleAmountChange}
                      autoComplete="off"
                      aria-label="balance"
                      width={mq.matches ? '100%' : 256}
                      errorMessage={error.balance}
                    />
                  </StyledInputValue>
                )}
              </StyledFieldContainer>
            
            {!isNonQual && (
              <>
                {!isYodleeAccount && (
                  <React.Fragment>
                    {isEligbleForERContribution(contributionType) && (
                      <StyledFieldContainer>
                        <StyledInputLabel
                          aria-describedby="annual-savings-tooltip"
                          tabIndex={0}
                          data-tip={annualERContTooltip()}
                        >
                          Annual Employer
                          <br />
                          Contribution
                          <Tooltip />
                          <img
                            src={`data:image/svg+xml;base64,${tokens.AssetImageDashedLine}`}
                            alt="dashed-underline"
                          />
                        </StyledInputLabel>
                        <Input
                          name="annualSavingsER"
                          value={
                            getIntegerAmount(annualSavingsER) >= 0
                              ? formatAmountWithoutDollarAndDecimals(annualSavingsER)
                              : ''
                          }
                          placeholder="Annual Savings Amount"
                          leadingCharacter="$"
                          onChange={this.handleAmountChange}
                          autoComplete="off"
                          aria-label="annualSavingsER"
                          width={mq.matches ? '100%' : 256}
                          errorMessage={error.annualSavingsER}
                        />
                      </StyledFieldContainer>
                    )}
                    {isEligbleForEEContribution(contributionType) && (
                      <StyledFieldContainer>
                        <StyledInputLabel
                          aria-describedby="annual-savings-tooltip"
                          tabIndex={0}
                          data-tip={annualEEContTooltip()}
                        >
                          Account Owner&apos;s <br />
                          Annual Savings
                          <Tooltip />
                          <img
                            src={`data:image/svg+xml;base64,${tokens.AssetImageDashedLine}`}
                            alt="dashed-underline"
                          />
                        </StyledInputLabel>
                        <Input
                          name="annualSavingsEE"
                          value={
                            getIntegerAmount(annualSavingsEE) >= 0
                              ? formatAmountWithoutDollarAndDecimals(annualSavingsEE)
                              : ''
                          }
                          placeholder="Annual Savings Amount"
                          leadingCharacter="$"
                          onChange={this.handleAmountChange}
                          autoComplete="off"
                          aria-label="annualSavingsEE"
                          width={mq.matches ? '100%' : 256}
                          errorMessage={error.annualSavingsEE}
                        />
                      </StyledFieldContainer>
                    )}
                  </React.Fragment>
                )}
              </>
            )}
            {accountHolderOptions.length === 1 || selectedAccount.type === "Hsa" ? (
              <StyledFieldContainer>
                <StyledInputLabel>Owner</StyledInputLabel>
                <StyledInputValue>
                  <Input
                    name="accountHolder"
                    value={accountHolder || ''}
                    placeholder="Participant Name"
                    autoComplete="off"
                    aria-label="owner"
                    width={mq.matches ? '100%' : 256}
                    disabled={true}
                    errorMessage={error.accountHolder}
                    className="blocked_data"
                  />
                </StyledInputValue>
              </StyledFieldContainer>
            ) : (
              <StyledFieldContainer>
                <StyledInputLabel>Owner </StyledInputLabel>
                <StyledInputValue>
                  <Dropdown
                    label="Select"
                    options={accountHolderOptions}
                    onChange={(option: any) => this.handleAccountHolderOptionChange(option)}
                    selectedOption={
                      accountHolderOptions.find((option: any) => option.name === accountHolder) || defaultOption
                    }
                    name="accountHolderOption"
                    width={mq.matches ? '100%' : 256}
                    errorMessage={error.accountHolder}
                    className="blocked_data"
                  />
                </StyledInputValue>
              </StyledFieldContainer>
            )}
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ accountTypes, account, riScenario }: any) => ({
  accountTypes: accountTypes.data,
  account,
  riScenario,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  updateField: addAccountActions.updateField,
  updateSelectedAccount: accountActions.updateSelectedAccount,
})(AddAccountBaseFields);
